import Component from '@bythepixel/component-loader';
import Splide from '@splidejs/splide';

export default class Highlights extends Component {
  static selector = '[data-comp-highlights]';
  static loaderPriority = 'in-view';

  constructor(containerEl) {
    super(containerEl);

    this.sliderContainer = this.$container.querySelector(
      '[data-highlights-slider]',
    );

    if (!this.sliderContainer) return;

    this.initSlider();
  }

  initSlider() {
    const splideOptions = {
      gap: 16,
      arrows: false,
      focus: 'center',
      perPage: 1,
      fixedWidth: 289,
      padding: {
        left: 30,
        right: 30,
      },
      mediaQuery: 'min',
      breakpoints: {
        768: {
          destroy: true,
          pagination: false,
        },
      },
    };

    this.slider = new Splide(this.sliderContainer, splideOptions).mount();
  }
}
